export function convertNumberToThaiBahtText(number) {
  const txtNumArr = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
  const txtDigitArr = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

  // แปลงให้เป็น string และลบ , กับ space
  number = Number(number).toFixed(2).toString().replace(/[, ]/g, "").split(".");

  function readNumber(numStr) {
    let text = "";
    const len = numStr.length;
    for (let i = 0; i < len; i++) {
      const digit = parseInt(numStr.charAt(i));
      if (digit === 0) continue;

      const position = len - i - 1;
      if (position === 0 && digit === 1 && len > 1) {
        text += "เอ็ด";
      } else if (position === 1 && digit === 2) {
        text += "ยี่";
      } else if (position === 1 && digit === 1) {
        text += "";
      } else {
        text += txtNumArr[digit];
      }
      text += txtDigitArr[position % 6];
      if (position >= 6 && position % 6 === 0) text += "ล้าน";
    }
    return text;
  }

  let integerPart = number[0];
  let decimalPart = number[1];

  // ตัดล้านซ้อน เช่น "123456789" → "123" ล้าน "456789"
  let bahtText = "";
  while (integerPart.length > 0) {
    const chunk = integerPart.length > 6 ? integerPart.slice(-6) : integerPart;
    bahtText = readNumber(chunk) + (bahtText ? "ล้าน" + bahtText : "");
    integerPart = integerPart.length > 6 ? integerPart.slice(0, -6) : "";
  }

  bahtText = bahtText || "ศูนย์";

  let satangText = "";
  if (decimalPart === "00") {
    satangText = "ถ้วน";
  } else {
    satangText = readNumber(decimalPart) + "สตางค์";
  }

  return bahtText + "บาท" + satangText;
}
